import { makeAjaxAction } from "@tencent/react-aio"

// 获取登录状态
export const FETCH_LOGIN_STATUS = makeAjaxAction("FETCH_LOGIN_STATUS")
// 获取用户信息
export const FETCH_USER = makeAjaxAction("FETCH_USER")

// 获取地域列表
export const FETCH_AREA_LIST = makeAjaxAction("FETCH_AREA_LIST")
// 获取行业列表
export const FETCH_INDUSTRY_LIST = makeAjaxAction("FETCH_INDUSTRY_LIST")
// 获取推广目标列表
export const FETCH_PROMOTED_OBJECT_LIST = makeAjaxAction("FETCH_PROMOTED_OBJECT_LIST")
// 获取线索来源列表
export const FETCH_SOURCE_TYPE_LIST = makeAjaxAction("FETCH_SOURCE_TYPE_LIST")
// 获取线索来源列表
export const FETCH_SOURCE_TYPE_TAG = makeAjaxAction("FETCH_SOURCE_TYPE_TAG")
// 获取服务商
export const FETCH_AGENCY = makeAjaxAction("FETCH_AGENCY")
// 获取服务商列表
export const FETCH_AGENCY_LIST = makeAjaxAction("FETCH_AGENCY_LIST")
// 获取服务商列表(size默认20)
export const FETCH_AGENCY_LIST_PAGE = makeAjaxAction("FETCH_AGENCY_LIST_PAGE")
// 获取呼叫中心座席信息
export const FETCH_SEAT_INFO = makeAjaxAction("FETCH_SEAT_INFO")
// 切换服务商
export const SWITCH_AGENCY = makeAjaxAction("SWITCH_AGENCY")
// 获取岗位列表
export const FETCH_POSITION_LIST = makeAjaxAction("FETCH_POSITION_LIST")
// 获取权限列表
export const FETCH_PRIVILEGE_LIST = makeAjaxAction("FETCH_PRIVILEGE_LIST")
// 获取员工列表
export const FETCH_EMPLOYEE_USER_LIST = makeAjaxAction("FETCH_EMPLOYEE_USER_LIST")
// 获取全部员工列表-用于一些select框的场景
export const FETCH_FULL_EMPLOYEE_USER_LIST = makeAjaxAction("FETCH_FULL_EMPLOYEE_USER_LIST")
// 获取员工
export const FETCH_EMPLOYEE_USER = makeAjaxAction("FETCH_EMPLOYEE_USER")
// 获取员工坐席信息
export const FETCH_EMPLOYEE_SEAT_INFO = makeAjaxAction("FETCH_EMPLOYEE_SEAT_INFO")
// 刷新员工
export const REFRESH_EMPLOYEE = "REFRESH_EMPLOYEE"
// 刷新员工权限
export const REFRESH_EMPLOYEE_PRIVILEGE = "REFRESH_EMPLOYEE_PRIVILEGE"
// 获取当前用户信息
export const FETCH_CURRENT_USER = makeAjaxAction("FETCH_CURRENT_USER")
// 刷新当前用户信息
export const REFRESH_CURRENT_USER = makeAjaxAction("REFRESH_CURRENT_USER")

// 获取服务商首选项
export const FETCH_AGENCY_PREFERENCE = makeAjaxAction("FETCH_AGENCY_PREFERENCE")
// 获取服务商渠道经理
export const FETCH_CHANNEL_MANAGER_LIST = makeAjaxAction("FETCH_CHANNEL_MANAGER_LIST")
export const FETCH_CHANNEL_MANAGER = makeAjaxAction("FETCH_CHANNEL_MANAGER")

// 刷新渠道经理
export const REFRESH_CHANNEL_MANAGER = "REFRESH_CHANNEL_MANAGER"

// 刷新服务商
export const REFRESH_AGENCY = "REFRESH_AGENCY"
// 刷新服务商首选项
export const REFRESH_AGENCY_PREFERENCE = "REFRESH_AGENCY_PREFERENCE"
// 刷新岗位
export const REFRESH_POSITION = "REFRESH_POSITION"

// 查询架构树
export const FETCH_ORGANIZATION_TREE = makeAjaxAction("FETCH_ORGANIZATION_TREE")

// 查询架构树带日期范围（目前应用于工作台下钻逻辑）
export const FETCH_ORGANIZATION_TREE_WITH_DATE_RANGE = makeAjaxAction("FETCH_ORGANIZATION_TREE_WITH_DATE_RANGE")

// 查询线索自定义列
export const FETCH_LEAD_CUSTOMIZED_FIELDS = makeAjaxAction("FETCH_LEAD_CUSTOMIZED_FIELDS")
// 查询商机自定义列
export const FETCH_POTENTIAL_CUSTOMIZED_FIELDS = makeAjaxAction("FETCH_POTENTIAL_CUSTOMIZED_FIELDS")
// 查询商机自定义列
export const FETCH_ORDER_CUSTOMIZED_FIELDS = makeAjaxAction("FETCH_ORDER_CUSTOMIZED_FIELDS")
// 查询转化量自定义列
export const FETCH_CONVERSION_CUSTOMIZED_FIELDS = makeAjaxAction("FETCH_CONVERSION_CUSTOMIZED_FIELDS")
// 查询转化率自定义列
export const FETCH_CONVERSION_RATE_CUSTOMIZED_FIELDS = makeAjaxAction("FETCH_CONVERSION_RATE_CUSTOMIZED_FIELDS")
// 查询效能评估自定义列
export const FETCH_EFFICIENCY_CUSTOMIZED_FIELDS = makeAjaxAction("FETCH_EFFICIENCY_CUSTOMIZED_FIELDS")

// 基础查询
export const FETCH_BASIC_QUERY_LIST = makeAjaxAction("FETCH_BASIC_QUERY_LIST")
// 获取线索列表
export const FETCH_LEAD_LIST = makeAjaxAction("FETCH_LEAD_LIST")
// 获取线索
export const FETCH_LEAD = makeAjaxAction("FETCH_LEAD")
// 创建线索
export const CREATE_LEAD = makeAjaxAction("CREATE_LEAD")
// 更新线索
export const UPDATE_LEAD = makeAjaxAction("UPDATE_LEAD")
// 清洗线索
export const CLEAN_LEAD = makeAjaxAction("CLEAN_LEAD")
// 分配线索
export const ASSIGN_LEAD = makeAjaxAction("ASSIGN_LEAD")
// 线索公海申领
export const OBTAIN_LEAD = makeAjaxAction("OBTAIN_LEAD")
// 释放线索到公海池
export const RELEASE_LEAD = makeAjaxAction("RELEASE_LEAD")
// 获取公海线索列表
export const FETCH_HIGHSEA_LEAD_LIST = makeAjaxAction("FETCH_HIGHSEA_LEAD_LIST")
// 转为商机
export const TO_POTENTIAL = makeAjaxAction("TO_POTENTIAL")
// 获取商机列表
export const FETCH_POTENTIAL_LIST = makeAjaxAction("FETCH_POTENTIAL_LIST")
// 获取公海商机列表
export const FETCH_HIGHSEA_LIST = makeAjaxAction("FETCH_HIGHSEA_LIST")
// 获取商机
export const FETCH_POTENTIAL = makeAjaxAction("FETCH_POTENTIAL")
// 更新商机
export const UPDATE_POTENTIAL = makeAjaxAction("UPDATE_POTENTIAL")
// 分配商机
export const ASSIGN_POTENTIAL = makeAjaxAction("ASSIGN_POTENTIAL")
// 释放商机到公海池
export const RELEASE_POTENTIAL = makeAjaxAction("RELEASE_POTENTIAL")
// 商机公海申领
export const OBTAIN_POTENTIAL = makeAjaxAction("OBTAIN_POTENTIAL")

export const FETCH_SEAT_ROLE_LIST = makeAjaxAction("FETCH_SEAT_ROLE_LIST")
export const FETCH_SEAT_SKILL_GROUP_LIST = makeAjaxAction("FETCH_SEAT_SKILL_GROUP_LIST")

// 获取客户信息
export const FETCH_CUSTOMER = makeAjaxAction("FETCH_CUSTOMER")

// 联系号码状态
export const CONTACT_PHONE_STATUS = makeAjaxAction("CONTACT_PHONE_STATUS")
export const CONTACT_PHONE_LIST_STATUS = makeAjaxAction("CONTACT_PHONE_LIST_STATUS")

export const DIAL_OUT = makeAjaxAction("DIAL_OUT")
export const CALL_CENTER_UPDATE = "CALL_CENTER_UPDATE"

// 获取订单列表
export const FETCH_ORDER_LIST = makeAjaxAction("FETCH_ORDER_LIST")
// 获取订单
export const FETCH_ORDER = makeAjaxAction("FETCH_ORDER")
// 分配订单
export const ASSIGN_ORDER = makeAjaxAction("ASSIGN_ORDER")
// 更新订单
export const UPDATE_ORDER = makeAjaxAction("UPDATE_ORDER")
// 订单到款确认
export const REVIEW_ORDER_PAYMENT = makeAjaxAction("REVIEW_ORDER_PAYMENT")
// 订单提交上线
export const SUBMIT_ORDER_ONLINE = makeAjaxAction("SUBMIT_ORDER_ONLINE")

// 获取话务分析明细列表
export const FETCH_REPORT_TRAFFIC_DETAIL_LIST = makeAjaxAction("FETCH_REPORT_TRAFFIC_DETAIL_LIST")
// 清空话务分析明细列表
export const CLEAR_REPORT_TRAFFIC_DETAIL_LIST = "CLEAR_REPORT_TRAFFIC_DETAIL_LIST"
// 获取话务分析统计列表
export const FETCH_REPORT_TRAFFIC_DAILY_LIST = makeAjaxAction("FETCH_REPORT_TRAFFIC_DAILY_LIST")
// 缓存筛选项，用于明细和统计切换
export const CACHE_REPORT_TRAFFIC_PARAMS = "CACHE_REPORT_TRAFFIC_PARAMS"

// 我的工作台-获取销售业绩报表
// 图表数据
export const FETCH_TEAM_SALE_DATA_CHART = makeAjaxAction("FETCH_TEAM_SALE_DATA_CHART")
// 表格根级数据
export const FETCH_ROOT_TEAM_SALE_DATA_LIST = makeAjaxAction("FETCH_ROOT_TEAM_SALE_DATA_LIST")
// 表格子级数据（除根级以外）
export const FETCH_TEAM_SALE_DATA_LIST = makeAjaxAction("FETCH_TEAM_SALE_DATA_LIST")

// 我的工作台-话务报表
// 表格根级数据
export const FETCH_ROOT_TEAM_CALL_DATA_LIST = makeAjaxAction("FETCH_ROOT_TEAM_CALL_DATA_LIST")
// 表格子级数据（除根级以外）
export const FETCH_TEAM_CALL_DATA_LIST = makeAjaxAction("FETCH_TEAM_CALL_DATA_LIST")

// 获取消耗列表
export const FETCH_PERFORMANCE_LIST = makeAjaxAction("FETCH_PERFORMANCE_LIST")
// 获取消耗列表
export const FETCH_REPORT_COST_LIST = makeAjaxAction("FETCH_REPORT_COST_LIST")

// 获取充值列表
export const FETCH_REPORT_CHARGE_LIST = makeAjaxAction("FETCH_REPORT_CHARGE_LIST")

// 修改外勤单列表查询参数
export const SET_QUERY_TYPE = "SET_QUERY_TYPE"

// 获取外勤单列表
export const FETCH_OUTSIDE_LIST = makeAjaxAction("FETCH_OUTSIDE_LIST")

// 获取外勤单数量
export const FETCH_OUTSIDE_COUNT = makeAjaxAction("FETCH_OUTSIDE_COUNT")

// 新建外勤单
export const CREATE_OUTSIDE = makeAjaxAction("CREATE_OUTSIDE")

// 编辑外勤单
export const UPDATE_OUTSIDE = makeAjaxAction("UPDATE_OUTSIDE")

// 获取外勤单
export const FETCH_OUTSIDE = makeAjaxAction("FETCH_OUTSIDE")

// 转移外勤单
export const OUTSIDE_TRANSFER = makeAjaxAction("OUTSIDE_TRANSFER")

// 获取下单产品列表
export const FETCH_ORDERING_PRODUCT_LIST = makeAjaxAction("FETCH_ORDERING_PRODUCT_LIST")

// 批量转移
export const BATCH_TRANSFER_OWNER = makeAjaxAction("BATCH_TRANSFER_OWNER")

// 获取业务分析转化量列表
export const FETCH_CONVERSION_QUANTITY_LIST = makeAjaxAction("FETCH_CONVERSION_QUANTITY_LIST")

// 获取业务分析转化量列表
export const FETCH_CONVERSION_RATE_QUANTITY_LIST = makeAjaxAction("FETCH_CONVERSION_RATE_QUANTITY_LIST")

// 获取业务分析转化量列表
export const FETCH_EFFICIENCY_EVALUATION_LIST = makeAjaxAction("FETCH_EFFICIENCY_EVALUATION_LIST")

// 缓存业务分析查询筛选条件
export const CACHE_BUSINESS_ANALYSIS_PARAMS = makeAjaxAction("CACHE_BUSINESS_ANALYSIS_PARAMS")

/**-------------- portal-fe 开户 -------------------------- */
// 新建开户单
export const CREATE_CLIENT = makeAjaxAction("CREATE_CLIENT")

// 编辑开户单
export const UPDATE_CLIENT = makeAjaxAction("UPDATE_CLIENT")

// 查询待分配开户单
export const SEARCH_UNASSIGNED_LIST = makeAjaxAction("SEARCH_UNASSIGNED_LIST")
// 查询开户单列表
export const SEARCH_REGISTER_LIST = makeAjaxAction("SEARCH_REGISTER_LIST")
// 获取开户人列表
export const FETCH_OPERATOR_LIST = makeAjaxAction("FETCH_OPERATOR_LIST")
// 获取开户人列表
export const ASSIGN_REVIEW = makeAjaxAction("ASSIGN_REVIEW")

// 转移开户单
export const REGISTRATION_TRANSFER = makeAjaxAction("REGISTRATION_TRANSFER")

/**-------------- portal-fe-end 开户  -------------------------- */

/**-------------- portal-fe 员工管理 -------------------------- */

// 获取当前用户可管理的服务商列表
export const FETCH_MANAGED_AGENCY_LIST = makeAjaxAction("FETCH_MANAGED_AGENCY_LIST")
// 获取当前运营管理员管理的员工列表
export const FETCH_BM_OPERATORS_LIST = makeAjaxAction("FETCH_BM_OPERATORS_LIST")
// 获取当前服务商下子客列表
export const FETCH_MANAGED_AGENCY_ADVERTISERS_LIST = makeAjaxAction("FETCH_MANAGED_AGENCY_ADVERTISERS_LIST")
// 获取当前运营管理员管理的员工列表
export const FETCH_MANAGED_BM_OPERATORS = makeAjaxAction("FETCH_MANAGED_BM_OPERATORS")
// 获取当前代理投放管理员管理的子客列表
export const FETCH_MANAGED_SUB_ADVERTISERS = makeAjaxAction("FETCH_MANAGED_SUB_ADVERTISERS")
// 获取职务列表
export const FETCH_TITLE_LIST = makeAjaxAction("FETCH_TITLE_LIST")
// 获取角色列表
export const FETCH_ROLE_LIST = makeAjaxAction("FETCH_ROLE_LIST")
// 获取雇员绑定的角色列表
export const FETCH_EMPLOYEE_BOUND_ROLES = makeAjaxAction("FETCH_EMPLOYEE_BOUND_ROLES")

export const SET_SELECTED_EMPLOYEE_LIST = "SET_SELECTED_EMPLOYEE_LIST"

/**-------------- portal-fe-end 员工管理 -------------------------- */

// OA域活动管理列表
export const FETCH_ACTIVITY_LIST_IN_OA = makeAjaxAction("FETCH_ACTIVITY_LIST_IN_OA")
// 推送短信号码包查询
export const FETCH_SMS_ACTIVITY_INFO = makeAjaxAction("FETCH_SMS_ACTIVITY_INFO")
// 发送短信号码包
export const FETCH_SMS_PACKAGE = makeAjaxAction("FETCH_SMS_PACKAGE")
// 获取分配处理人列表
export const FETCH_ASSIGN_PROCESSOR_LIST = makeAjaxAction("FETCH_ASSIGN_PROCESSOR_LIST")
// 获取清洗原因配置
export const FETCH_CLEAN_REASON_CONFIG = makeAjaxAction("FETCH_CLEAN_REASON_CONFIG")
// 获取呼入白名单
export const FETCH_CUSTOMER_PROTECTION_WHITE_LIST = makeAjaxAction("FETCH_CUSTOMER_PROTECTION_WHITE_LIST")
// 获取总机号码
export const FETCH_LIST_DISPLAY_NUMBER = makeAjaxAction("FETCH_LIST_DISPLAY_NUMBER")
// 企微标签
export const FETCH_WECHAT_LABEL_LIST = makeAjaxAction("FETCH_WECHAT_LABEL_LIST")

